var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-8"},[(_vm.isLoading)?_c('loading-indicator'):_c('p',{staticClass:"text-slate text-lg text-center"},[_vm._v(_vm._s(_vm.audience_listing.title)+" has nothing scheduled at this time.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }